import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=5e2c3eb3"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"
import style0 from "./TabPanel.vue?vue&type=style&index=0&id=5e2c3eb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports